module.exports = __webpack_public_path__ + "static/media/pragmatics5e9dbe49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/pragmatics.svg
// module id = 1336
// module chunks = 0